/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

function Ir2023({ posts, categories }) {
  const router = useRouter();
  useEffect(() => {
    router.replace(`/blog/declaracao-de-imposto-de-renda.html${window.location.search}`);
  }, []);
  return <>{/*  */}</>;
}

export const config = {
  amp: false,
};

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default Ir2023;
